<div class="identity-members">
  <app-table
    [columns]="tableColumns"
    [data]="group.records || []"
    [loading]="group.isLoadingMembers || false"
    [noResultsMessage]="'No member records found for this duplicate group.'"
    [skeletonRows]="3"
  >
    <ng-template let-rec>
      <tr>
        <td class="font-semibold">
          {{ rec.business_name || "Unnamed Business" }}
        </td>
        <td class="text-sub">
          <code>{{ rec.unique_id }}</code>
        </td>
        <td>{{ rec.email || "-" }}</td>
        <td>{{ rec.city || "-" }}, {{ rec.state || "-" }}</td>
        <td>
          <span class="user-chip">{{
            cleanUsername(rec.created_by_user)
          }}</span>
        </td>
        <td style="text-align: right">
          <div class="action-icons">
            <a href="javascript:void(0)" (click)="onViewDetails(rec.unique_id)">
              View
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>

  <!-- Progressive "Load More Records" Lazy Loading Button -->
  @if (!group.isLoadingMembers && group.hasMoreMembers) {
    <div class="load-more-container">
      <button
        class="btn-load-more"
        [disabled]="group.isLoadingMore"
        (click)="loadMoreMembers()"
      >
        @if (!group.isLoadingMore) {
          <span>
            Load More Records ({{
              (group.membersTotal || 0) - (group.records?.length || 0)
            }}
            remaining)
          </span>
        }
        @if (group.isLoadingMore) {
          <span class="loading-inline">
            <div class="spinner-xs"></div>
            Loading next batch...
          </span>
        }
      </button>
    </div>
  }
</div>
